import React from "react";

import * as IconsSVG from "../../../../../assets/iconsSVG";
import productBG from "../../../../../assets/images/image-not-found.jpg";
import * as Styles from "./styles";

interface Props {
  idEmpreendimento: string;
  nomeEmpreendimento: string;
  nomeBandeira: string;
  urlImagemPrincipal: string | undefined;
  statusEmpreendimento: string | undefined;
}

export function ProductCard(props: Props) {
  return (
    // <Styles.ProductCard href={`/produtos/${props.idEmpreendimento}`}> enquanto nao temos feature produtos
    <Styles.ProductCard>
      <Styles.BoxImg>
        <img src={props.urlImagemPrincipal || productBG} alt="Product img" />
        <Styles.Flag>
          {props.nomeBandeira === "CYRELA" && <IconsSVG.CyrelaIcon />}
          {props.nomeBandeira === "LIVING" && <IconsSVG.LivingIcon />}
          {props.nomeBandeira === "Outros" && <IconsSVG.VivazIcon />}
        </Styles.Flag>
        <Styles.Status>{props.statusEmpreendimento || "--"}</Styles.Status>
      </Styles.BoxImg>
      <Styles.BoxContent>
        <Styles.PrdTitle>{props.nomeEmpreendimento || "--"}</Styles.PrdTitle>
      </Styles.BoxContent>
    </Styles.ProductCard>
  );
}
